<template>
  <div>
    <nav-title :color="false" :title="'Update Child Profile'" />
    <select-child :users="getChildrenData" :router="url" :showDisabled="true" />
  </div>
</template>
<script>
import navTitle from "@/components/general/navTitle.vue";
import selectChild from "@/components/general/selectChild.vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      url: this.$route.query.next
    };
  },
  components: {
    navTitle,
    selectChild
  },
  computed: {
    ...mapGetters("parent", ["getChildrenData"])
  },
  beforeRouteEnter(to, from, next) {
    next();
  }
};
</script>